<template>
  <router-view />
</template>

<style lang="stylus">
@import './styles/global.styl';
</style>
